import { storeToRefs } from 'pinia';

import {
  ComplianceApiComplianceLicensesCreateRequest,
  ComplianceApiComplianceLicensesListRequest,
  ComplianceApiComplianceLicenseTypesListRequest,
  ComplianceApiFactory,
  LicenseCreateUpdateRequest,
} from '@/clients/unifiedApi';
import { URLS } from '@/constants';
import { CompanyLicense } from '@/models/company';
import { useCompanyStore } from '@/piniaStores/company/company.store';
import { apiSlugSession } from '@/services/session';

import { getUnifiedApi } from './unifiedApi';

/**
 * Fetches all states from users country
 */
export const getStates = async () => {
  const response = await apiSlugSession.get(URLS.STATES.LIST);

  return response.data;
};

export interface GetCompanyLicensesResponse {
  active: CompanyLicense[];
  archived: CompanyLicense[];
  pending: CompanyLicense[];
}

/**
 * Gets array of company licenses
 */
export const getCompanyLicenses = async () => {
  const response = await apiSlugSession.get<GetCompanyLicensesResponse>(URLS.SETTINGS.LICENSES.COMPANY_LICENSES);

  return response.data;
};

export async function getCompanyLicensesUnified(params: Partial<ComplianceApiComplianceLicensesListRequest>) {
  const { activeCompanyId } = storeToRefs(useCompanyStore());

  const api = await getUnifiedApi(ComplianceApiFactory);
  const response = await api.complianceLicensesList({
    companyId: [Number(activeCompanyId.value)],
    ...params,
  });

  return response.data.results;
}

export const getLicenseTypes = async (params: Partial<ComplianceApiComplianceLicenseTypesListRequest> = {}) => {
  const { activeCompanyId } = storeToRefs(useCompanyStore());

  const api = await getUnifiedApi(ComplianceApiFactory);
  const response = await api.complianceLicenseTypesList({ companyId: Number(activeCompanyId.value), ...params });

  return response.data.results;
};

export async function createLicenses(licenses: LicenseCreateUpdateRequest[]) {
  const { activeCompany } = useCompanyStore();

  const api = await getUnifiedApi(ComplianceApiFactory);

  const params = {
    companyId: activeCompany?.id,
    licenseCreateUpdateRequest: licenses,
  } as ComplianceApiComplianceLicensesCreateRequest;

  const response = await api.complianceLicensesCreate(params);

  return response.data;
}
